import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { Observable, from, map, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { UserApi } from "../../api/user.api";

@Injectable({ providedIn: "root" })
export class FormValidator {
	constructor(private readonly userApi: UserApi) {}

	/**
	 * Async validator that flags the email when another user already has it.
	 * `excludeUserId` is the user being edited, so its own email is not
	 * reported as taken.
	 */
	emailExistsValidator(
		excludeUserId?: string,
	): (control: AbstractControl) => Observable<ValidationErrors | null> {
		return (control: AbstractControl): Observable<ValidationErrors | null> => {
			if (!control.value) {
				return of(null);
			}

			return from(this.userApi.exists(control.value, excludeUserId)).pipe(
				map((emailExists) => {
					return emailExists ? { emailExists: true } : null;
				}),
				catchError(() => of({ emailExists: true })),
			);
		};
	}

	greaterThanZeroValidator(control: AbstractControl): ValidationErrors | null {
		if (control.value <= 0) return { lessThanZero: true };
		return null;
	}
}
